import type { useCreateHardEligibilitySession } from "@usebridge/sdk-react"

type Session = ReturnType<ReturnType<typeof useCreateHardEligibilitySession>>
type Result = Session["state"]
export type InsuranceMember = { firstName: string; lastName: string; dateOfBirth: string }
export type InsuranceInputs = {
  state: string
  payerId: string
  payerName: string
  memberId: string
}
export type InsuranceCheckInputs = InsuranceInputs & { serviceTypeIds: string[]; member: InsuranceMember }
export type InsuranceResult = Pick<
  Result,
  "providers" | "patientResponsibility" | "serviceEligibility" | "ineligibilityReason"
> & {
  status: "ELIGIBLE" | "INELIGIBLE"
  policyId?: string
}
export type InsuranceError = { code: string; retryable: boolean }
export type InsuranceEvent =
  | { type: "INSURANCE_STARTED"; requestId: string; inputs: InsuranceCheckInputs }
  | { type: "INSURANCE_RESULT"; requestId: string; result: InsuranceResult }
  | { type: "INSURANCE_FAILED"; requestId: string; error: InsuranceError }
  | { type: "INSURANCE_INVALIDATED" }

export function insuranceResultStep(result: InsuranceResult): "covered" | "notCovered" | "noProviders" {
  if (result.status === "ELIGIBLE") return result.providers?.length ? "covered" : "noProviders"
  return result.ineligibilityReason?.code === "PROVIDERS" || result.ineligibilityReason?.code === "OUT_OF_NETWORK"
    ? "noProviders"
    : "notCovered"
}
